import { isPlatformServer } from '@angular/common';
import { InjectionToken, PLATFORM_ID, REQUEST_CONTEXT, inject } from '@angular/core';

export const ROUTE_EXPLORATION = new InjectionToken<boolean>('REQUEST_EXPLORATION', {
    providedIn: 'root',
    factory: () => isPlatformServer(inject(PLATFORM_ID)) && Object.is(inject(REQUEST_CONTEXT), null),
});
